<template>
  <div class="k-loading" />
</template>

<script>
export default {
  name: 'Loading',
};
</script>
